// extracted by mini-css-extract-plugin
export default {"button":"FavoriteButton_button--rxH","label":"FavoriteButton_label--gj8"};